(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('brand-marquee')) return;

    const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

    class BrandMarquee extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.pauseBtn = this.querySelector('[data-pause]');
        this.pauseLabel = this.querySelector('[data-pause-label]');
        this.rows = Array.from(this.querySelectorAll('[data-row]')).map((el) => ({
          el,
          skew: el.querySelector('[data-skew]'),
          track: el.querySelector('[data-track]'),
          group: el.querySelector('[data-group]'),
          speed: parseFloat(el.dataset.speed) || 48,
          reverse: el.dataset.dir === 'right',
          anim: null,
          lastSkew: 0
        }));

        this.rate = 1;
        this.v = 0;
        this.lastY = window.scrollY;
        this.last = 0;
        this.raf = 0;
        this.visible = false;
        this.userPaused = false;
        this.hover = false;
        this.focused = false;
        this.touching = false;
        this.touchTimer = 0;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.reduce = this.motion.matches;

        this.setAttribute('data-ready', '');
        this.bindReveal();
        this.bindInput();

        this.onMotionChange = (e) => {
          this.reduce = e.matches;
          if (this.reduce) this.teardown();
          else this.build();
        };
        this.motion.addEventListener('change', this.onMotionChange);

        if (this.reduce) {
          this.classList.add('is-in');
        } else {
          this.build();
        }
      }

      disconnectedCallback() {
        this.teardown();
        if (this.io) this.io.disconnect();
        if (this.visIo) this.visIo.disconnect();
        if (this.motion && this.onMotionChange) {
          this.motion.removeEventListener('change', this.onMotionChange);
        }
        window.removeEventListener('scroll', this.onScroll);
        this._ready = false;
      }

      /* One-shot entrance */
      bindReveal() {
        if (this.reduce || !('IntersectionObserver' in window)) {
          this.classList.add('is-in');
          return;
        }
        this.io = new IntersectionObserver(
          (entries) => {
            if (entries.some((e) => e.isIntersecting)) {
              this.classList.add('is-in');
              this.io.disconnect();
            }
          },
          { threshold: 0.15 }
        );
        this.io.observe(this);
      }

      /* Hold sources: pause button, hover, keyboard focus, touch */
      bindInput() {
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.toggleAttribute('data-paused', this.userPaused);
            if (this.pauseLabel) this.pauseLabel.textContent = this.userPaused ? 'Play' : 'Pause';
            if (!this.userPaused) this.wake();
          });
        }

        this.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.hover = true;
        });
        this.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.hover = false;
          this.wake();
        });
        this.addEventListener('focusin', () => {
          this.focused = true;
        });
        this.addEventListener('focusout', () => {
          this.focused = false;
          this.wake();
        });

        // Moving targets are hard to tap — freeze instantly on touch, resume shortly after release.
        this.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse') return;
          clearTimeout(this.touchTimer);
          this.touching = true;
          this.rate = 0;
          this.applyRate();
        });
        const release = (e) => {
          if (e.pointerType === 'mouse') return;
          clearTimeout(this.touchTimer);
          this.touchTimer = setTimeout(() => {
            this.touching = false;
            this.wake();
          }, 900);
        };
        this.addEventListener('pointerup', release);
        this.addEventListener('pointercancel', release);
      }

      isHeld() {
        return this.userPaused || this.hover || this.focused || this.touching;
      }

      build() {
        this.teardown();
        if (!this.rows.length || typeof Element.prototype.animate !== 'function') return;

        this.setAttribute('data-motion', '');
        if (this.pauseBtn) this.pauseBtn.hidden = false;

        this.rows.forEach((row) => {
          const width = row.group.getBoundingClientRect().width;
          if (!width) return;
          row.anim = row.track.animate(
            [{ transform: 'translate3d(0, 0, 0)' }, { transform: 'translate3d(-50%, 0, 0)' }],
            {
              duration: this.durationFor(row, width),
              iterations: Infinity,
              easing: 'linear',
              direction: row.reverse ? 'reverse' : 'normal'
            }
          );
        });

        this.onScroll = () => this.wake();
        window.addEventListener('scroll', this.onScroll, { passive: true });

        this.resizeObs = new ResizeObserver(() => this.retime());
        this.rows.forEach((row) => this.resizeObs.observe(row.group));

        this.visIo = new IntersectionObserver(
          (entries) => {
            this.visible = entries.some((e) => e.isIntersecting);
            this.rows.forEach((row) => {
              if (!row.anim) return;
              if (this.visible) row.anim.play();
              else row.anim.pause();
            });
            if (this.visible) {
              this.lastY = window.scrollY;
              this.wake();
            }
          },
          { rootMargin: '80px 0px' }
        );
        this.visIo.observe(this);
      }

      durationFor(row, width) {
        const scale = window.innerWidth < 750 ? 0.6 : 1;
        return (width / (row.speed * scale)) * 1000;
      }

      /* Keep each row's phase when fonts load or the viewport resizes */
      retime() {
        this.rows.forEach((row) => {
          if (!row.anim) return;
          const width = row.group.getBoundingClientRect().width;
          if (!width) return;
          const oldDuration = row.anim.effect.getTiming().duration;
          const next = this.durationFor(row, width);
          if (Math.abs(next - oldDuration) < 1) return;
          const phase = ((row.anim.currentTime || 0) % oldDuration) / oldDuration;
          row.anim.effect.updateTiming({ duration: next });
          row.anim.currentTime = phase * next;
        });
      }

      teardown() {
        cancelAnimationFrame(this.raf);
        this.raf = 0;
        if (this.resizeObs) this.resizeObs.disconnect();
        if (this.visIo) this.visIo.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        this.rows.forEach((row) => {
          if (row.anim) row.anim.cancel();
          row.anim = null;
          if (row.skew) row.skew.style.transform = '';
        });
        this.removeAttribute('data-motion');
        if (this.pauseBtn) this.pauseBtn.hidden = true;
      }

      wake() {
        if (this.raf || !this.visible || this.reduce) return;
        this.last = performance.now() - 16;
        this.raf = requestAnimationFrame((t) => this.tick(t));
      }

      applyRate() {
        this.rows.forEach((row) => {
          if (row.anim) row.anim.updatePlaybackRate(this.rate);
        });
      }

      /* Scroll velocity -> drift speed + lean. Idles itself when nothing changes. */
      tick(now) {
        this.raf = 0;
        const dt = clamp(now - this.last, 1, 64);
        this.last = now;

        const y = window.scrollY;
        const instant = ((y - this.lastY) / dt) * 1000;
        this.lastY = y;
        this.v += (instant - this.v) * (1 - Math.exp(-dt / 90));

        const held = this.isHeld();
        const target = held ? 0 : 1 + clamp(Math.abs(this.v) / 450, 0, 4.5);
        const tau = target < this.rate ? 160 : 110;
        const prev = this.rate;
        this.rate += (target - this.rate) * (1 - Math.exp(-dt / tau));
        if (target === 0 && this.rate < 0.004) this.rate = 0;
        if (Math.abs(this.rate - prev) > 0.004 || this.rate === 0) this.applyRate();

        const maxLean = window.innerWidth < 750 ? 4 : 6;
        const lean = held ? 0 : clamp(this.v / 260, -maxLean, maxLean);
        this.rows.forEach((row) => {
          if (!row.skew) return;
          if (Math.abs(lean - row.lastSkew) < 0.01 && lean !== 0) return;
          row.lastSkew = lean;
          row.skew.style.transform = Math.abs(lean) < 0.02 ? '' : 'skewX(' + -lean.toFixed(2) + 'deg)';
        });

        const settled = Math.abs(this.rate - target) < 0.003 && Math.abs(this.v) < 1;
        if (this.visible && !(settled && (target === 0 || target === 1))) {
          this.raf = requestAnimationFrame((t) => this.tick(t));
        } else {
          if (target === 1) this.rate = 1;
          this.v = 0;
          this.applyRate();
          this.rows.forEach((row) => {
            if (row.skew) row.skew.style.transform = '';
            row.lastSkew = 0;
          });
          this.lastY = window.scrollY;
        }
      }
    }

    customElements.define('brand-marquee', BrandMarquee);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-tiles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('category-showcase')) return;

    customElements.define(
      'category-showcase',
      class extends HTMLElement {
        connectedCallback() {
          const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const design = !!(window.Shopify && window.Shopify.designMode);
          if (!fine || reduce || design || window.innerWidth < 750) return;

          this.raf = 0;
          this.x = 0;
          this.y = 0;
          this.tx = 0;
          this.ty = 0;
          this.placed = false;
          this.tick = this.tick.bind(this);
          this.onMove = this.onMove.bind(this);
          this.onLeave = this.onLeave.bind(this);

          // Decorative lens that trails the pointer. Springs, because it has no job
          // beyond feeling alive; the real affordance (the link) is untouched.
          this.cursor = document.createElement('span');
          this.cursor.className = 'category-tiles__cursor';
          this.cursor.setAttribute('aria-hidden', 'true');
          const lens = document.createElement('span');
          lens.className = 'category-tiles__cursor-lens';
          lens.textContent = this.dataset.cursorLabel || 'Shop';
          this.cursor.appendChild(lens);
          this.appendChild(this.cursor);

          this.addEventListener('pointermove', this.onMove, { passive: true });
          this.addEventListener('pointerleave', this.onLeave, { passive: true });
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.raf);
          this.removeEventListener('pointermove', this.onMove);
          this.removeEventListener('pointerleave', this.onLeave);
        }

        onMove(event) {
          this.tx = event.clientX;
          this.ty = event.clientY;
          if (!this.placed) {
            // First contact: appear under the pointer instead of flying in from the corner.
            this.x = this.tx;
            this.y = this.ty;
            this.placed = true;
          }
          const over = event.target.closest && event.target.closest('.category-tile__link');
          this.cursor.classList.toggle('is-active', !!over);
          if (!this.raf) this.raf = requestAnimationFrame(this.tick);
        }

        onLeave() {
          this.cursor.classList.remove('is-active');
        }

        tick() {
          this.x += (this.tx - this.x) * 0.2;
          this.y += (this.ty - this.y) * 0.2;
          this.cursor.style.translate = this.x.toFixed(1) + 'px ' + this.y.toFixed(1) + 'px';
          if (Math.abs(this.tx - this.x) > 0.2 || Math.abs(this.ty - this.y) > 0.2) {
            this.raf = requestAnimationFrame(this.tick);
          } else {
            this.raf = 0;
          }
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    if (window.__adotFooterV2) return;
    window.__adotFooterV2 = true;

    var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    // Keep this identical to the curtain media query in the stylesheet
    var mqCurtain = window.matchMedia('(min-width: 990px) and (min-height: 720px)');

    function clamp(n, lo, hi) { return Math.min(hi, Math.max(lo, n)); }
    function onChange(mq, fn) {
      if (mq.addEventListener) mq.addEventListener('change', fn);
      else if (mq.addListener) mq.addListener(fn);
    }

    /* ---------------------------------------------------------------
       1 · Reveal trigger + curtain depth (--reveal 0 → 1)
       --------------------------------------------------------------- */
    function initReveal(root) {
      var visible = false, queued = false, live = false;

      function frame() {
        queued = false;
        var rect = root.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = clamp((vh - rect.top) / Math.min(rect.height || vh, vh), 0, 1);
        root.style.setProperty('--reveal', p.toFixed(3));
      }

      function onScroll() {
        if (visible && !queued) { queued = true; requestAnimationFrame(frame); }
      }

      function sync() {
        var want = mqCurtain.matches && !mqReduce.matches && !root.hasAttribute('data-static');
        if (want && !live) {
          live = true;
          window.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', onScroll);
          frame();
        } else if (!want && live) {
          live = false;
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          root.style.setProperty('--reveal', '1');
        }
      }

      onChange(mqCurtain, sync);
      onChange(mqReduce, sync);
      sync();

      if (!('IntersectionObserver' in window)) { root.classList.add('is-in'); return; }

      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        visible = e.isIntersecting;
        if (visible) {
          onScroll();
          if (e.intersectionRatio >= 0.12) root.classList.add('is-in');
        }
      }, { threshold: [0, 0.12] }).observe(root);
    }

    /* ---------------------------------------------------------------
       2 · Fit the wordmark edge to edge
       Measures the text width in em once fonts are ready. CSS does the rest.
       --------------------------------------------------------------- */
    function initWordmark(root) {
      var text = root.querySelector('[data-wm-text]');
      if (!text) return;

      function measure() {
        var fs = parseFloat(getComputedStyle(text).fontSize);
        var w = text.getBoundingClientRect().width;
        if (!fs || !w) return;
        var em = w / fs;
        root.style.setProperty('--wm-em', em.toFixed(4));
        root.style.setProperty('--wm-ar', (em / 0.76).toFixed(4));
      }

      measure();
      if (document.fonts) {
        if (document.fonts.ready) document.fonts.ready.then(measure);
        if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', measure);
      }
    }

    /* ---------------------------------------------------------------
       3 · Support status (open / closed) from theme settings
       --------------------------------------------------------------- */
    function zoned(tz) {
      try {
        var parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: tz || undefined, hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
        }).formatToParts(new Date());
        var out = {};
        parts.forEach(function (p) {
          if (p.type === 'hour' || p.type === 'minute') out[p.type] = parseInt(p.value, 10);
        });
        return { h: out.hour % 24, m: out.minute };
      } catch (e) { return null; }
    }

    function tick() {
      var nodes = document.querySelectorAll('[data-footer-status]');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var t = zoned(el.getAttribute('data-tz'));
        var o = parseInt(el.getAttribute('data-open-hour'), 10);
        var c = parseInt(el.getAttribute('data-close-hour'), 10);
        if (!t || isNaN(o) || isNaN(c)) continue;
        var open = o <= c ? (t.h >= o && t.h < c) : (t.h >= o || t.h < c);
        el.setAttribute('data-open', open ? 'true' : 'false');
        var label = el.querySelector('[data-footer-status-text]');
        if (label) label.textContent = el.getAttribute(open ? 'data-label-open' : 'data-label-closed');
      }
    }

    var ticking = false;
    function startTicker() {
      if (ticking) return;
      ticking = true;
      (function schedule() {
        setTimeout(function () {
          if (!document.hidden) tick();
          schedule();
        }, (61 - new Date().getSeconds()) * 1000);
      })();
      document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
    }

    /* ---------------------------------------------------------------
       4 · Newsletter without leaving the page
       Verify once in DevTools: after a successful POST the final response URL contains
       customer_posted=true. If anything else happens we fall back to the normal submit,
       so the worst case is the old behaviour. To disable, delete initForm.
       --------------------------------------------------------------- */
    function initForm(root) {
      var form = root.querySelector('.footer__form');
      if (!form) return;
      var ok = form.querySelector('.footer__success');
      var live = root.querySelector('[data-footer-live]');
      var busy = false;

      form.addEventListener('submit', function (e) {
        if (busy) { e.preventDefault(); return; }
        if (!window.fetch || !form.checkValidity()) return;

        e.preventDefault();
        busy = true;
        form.setAttribute('data-state', 'loading');
        form.setAttribute('aria-busy', 'true');

        fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
          .then(function (res) {
            if (/customer_posted=true/.test(res.url || '')) {
              form.setAttribute('data-state', 'success');
              form.removeAttribute('aria-busy');
              if (ok) ok.setAttribute('data-visible', '');
              if (live) live.textContent = ok ? ok.textContent.trim() : '';
            } else {
              form.submit(); // captcha challenge, validation error, anything unexpected
            }
          })
          .catch(function () { form.submit(); });
      });
    }

    /* ---------------------------------------------------------------
       5 · Copy number + eased back-to-top (delegated)
       --------------------------------------------------------------- */
    function copyNumber(btn) {
      var text = btn.getAttribute('data-footer-copy');
      var live = document.querySelector('[data-footer-live]');

      function done() {
        btn.setAttribute('data-copied', '');
        if (live) live.textContent = 'Phone number copied';
        clearTimeout(btn.__adotT);
        btn.__adotT = setTimeout(function () {
          btn.removeAttribute('data-copied');
          if (live) live.textContent = '';
        }, 1800);
      }

      function fallback() {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
        document.body.appendChild(ta);
        ta.select();
        try { if (document.execCommand('copy')) done(); } catch (e) {}
        document.body.removeChild(ta);
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(done, fallback);
      } else {
        fallback();
      }
    }

    var cancelScroll = false;
    ['wheel', 'touchstart', 'keydown'].forEach(function (name) {
      window.addEventListener(name, function () { cancelScroll = true; }, { passive: true });
    });

    function toTop() {
      var start = window.pageYOffset || document.documentElement.scrollTop;
      if (!start) return;
      if (mqReduce.matches) { window.scrollTo(0, 0); return; }

      var html = document.documentElement;
      var prev = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      var duration = clamp(Math.sqrt(start) * 40, 700, 1600);
      var t0 = performance.now();
      cancelScroll = false;

      function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

      function step(now) {
        var t = clamp((now - t0) / duration, 0, 1);
        window.scrollTo(0, Math.round(start * (1 - ease(t))));
        if (t < 1 && !cancelScroll) requestAnimationFrame(step);
        else html.style.scrollBehavior = prev;
      }
      requestAnimationFrame(step);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-footer-top]')) { toTop(); return; }
      var copy = e.target.closest('[data-footer-copy]');
      if (copy) copyNumber(copy);
    });

    /* ---------------------------------------------------------------
       Boot (also re-runs inside the theme editor)
       --------------------------------------------------------------- */
    function boot(scope) {
      var roots = (scope || document).querySelectorAll('[data-footer-reveal]');
      for (var i = 0; i < roots.length; i++) {
        var root = roots[i];
        if (root.__adotFooter) continue;
        root.__adotFooter = true;
        initReveal(root);
        initWordmark(root);
        initForm(root);
      }
      tick();
      startTicker();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('editorial-hero')) return;

    customElements.define(
      'editorial-hero',
      class extends HTMLElement {
        connectedCallback() {
          this.onScrollCue = this.onScrollCue.bind(this);
          this.onMove = this.onMove.bind(this);
          this.onLeave = this.onLeave.bind(this);
          this.onButtonMove = this.onButtonMove.bind(this);
          this.onButtonLeave = this.onButtonLeave.bind(this);

          // The scroll cue always works, motion or not: it jumps to the next section.
          this.cue = this.querySelector('[data-hero-scroll]');
          if (this.cue) this.cue.addEventListener('click', this.onScrollCue);

          const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const design = !!(window.Shopify && window.Shopify.designMode);
          if (!fine || reduce || design) return;

          // Slow photographic drift. Decorative, so it springs rather than tracks.
          this.picture = this.querySelector('.hero__picture');
          if (this.picture) {
            this.addEventListener('pointermove', this.onMove, { passive: true });
            this.addEventListener('pointerleave', this.onLeave, { passive: true });
          }

          // Magnetic primary button: it leans toward the pointer, a few pixels only.
          this.button = this.querySelector('.btn-hero-primary');
          if (this.button) {
            this.button.addEventListener('pointermove', this.onButtonMove, { passive: true });
            this.button.addEventListener('pointerleave', this.onButtonLeave, { passive: true });
          }
        }

        disconnectedCallback() {
          if (this.cue) this.cue.removeEventListener('click', this.onScrollCue);
          this.removeEventListener('pointermove', this.onMove);
          this.removeEventListener('pointerleave', this.onLeave);
          if (this.button) {
            this.button.removeEventListener('pointermove', this.onButtonMove);
            this.button.removeEventListener('pointerleave', this.onButtonLeave);
          }
        }

        onScrollCue(event) {
          const wrapper = this.closest('.shopify-section');
          const next = wrapper && wrapper.nextElementSibling;
          if (!next) return;
          event.preventDefault();
          next.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        onMove(event) {
          const x = (event.clientX / window.innerWidth - 0.5) * 2;
          const y = (event.clientY / window.innerHeight - 0.5) * 2;
          this.picture.style.translate = (x * -14).toFixed(1) + 'px ' + (y * -8).toFixed(1) + 'px';
        }

        onLeave() {
          this.picture.style.translate = '';
        }

        onButtonMove(event) {
          const rect = this.button.getBoundingClientRect();
          const dx = event.clientX - (rect.left + rect.width / 2);
          const dy = event.clientY - (rect.top + rect.height / 2);
          const clamp = (v) => Math.max(-6, Math.min(6, v));
          this.button.style.translate = clamp(dx * 0.14).toFixed(1) + 'px ' + clamp(dy * 0.2).toFixed(1) + 'px';
        }

        onButtonLeave() {
          this.button.style.translate = '';
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
